'use client';

import { VideoNode } from '@prezly/story-content-format';
import classNames from 'classnames';
import { useState } from 'react';
import { HtmlInjection } from "../../components/index.mjs";
import { PlayButton } from "../../icons/index.mjs";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Video(_ref) {
  var {
    className,
    node,
    onPlay
  } = _ref;
  var {
    oembed,
    url,
    layout
  } = node;
  var [isHtmlEmbeddedWithErrors, setHtmlEmbeddedWithErrors] = useState(false);
  return /*#__PURE__*/_jsx("div", {
    className: classNames('prezly-slate-video', className),
    children: !isHtmlEmbeddedWithErrors && oembed.html ? /*#__PURE__*/_jsx(HtmlInjection, {
      className: classNames('prezly-slate-video__html', {
        'prezly-slate-video__html--contained': layout === VideoNode.Layout.CONTAINED,
        'prezly-slate-video__html--expanded': layout === VideoNode.Layout.EXPANDED,
        'prezly-slate-video__html--full-width': layout === VideoNode.Layout.FULL_WIDTH
      }),
      id: "video-".concat(node.uuid),
      html: oembed.html,
      onError: () => setHtmlEmbeddedWithErrors(true),
      onPlay: onPlay
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Thumbnail, {
        node: node
      }), /*#__PURE__*/_jsx(PlayButtonOverlay, {
        id: "video-".concat(node.uuid),
        href: url,
        title: node.oembed.title
      })]
    })
  });
}
function Thumbnail(_ref2) {
  var {
    node
  } = _ref2;
  var {
    layout,
    oembed
  } = node;
  var {
    thumbnail_url: src,
    thumbnail_height: height,
    thumbnail_width: width
  } = oembed;
  var paddingBottom = width && height ? "".concat(Math.round(100 * height / width), "%") : undefined;
  if (!src) {
    return /*#__PURE__*/_jsx(ThumbnailPlaceholder, {
      className: classNames({
        'prezly-slate-video__thumbnail-placeholder--contained': layout === VideoNode.Layout.CONTAINED,
        'prezly-slate-video__thumbnail-placeholder--expanded': layout === VideoNode.Layout.EXPANDED,
        'prezly-slate-video__thumbnail-placeholder--full-width': layout === VideoNode.Layout.FULL_WIDTH
      }),
      style: {
        paddingBottom
      }
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: classNames('prezly-slate-video__thumbnail', {
      'prezly-slate-video__thumbnail--contained': layout === VideoNode.Layout.CONTAINED,
      'prezly-slate-video__thumbnail--expanded': layout === VideoNode.Layout.EXPANDED,
      'prezly-slate-video__thumbnail--full-width': layout === VideoNode.Layout.FULL_WIDTH
    }),
    children: /*#__PURE__*/_jsx("img", {
      className: "prezly-slate-video__thumbnail-image",
      src: src,
      alt: "Video thumbnail"
    })
  });
}
function ThumbnailPlaceholder(_ref3) {
  var {
    className,
    style
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('prezly-slate-video__thumbnail-placeholder', className),
    style: style
  });
}
function PlayButtonOverlay(_ref4) {
  var {
    id,
    href,
    title
  } = _ref4;
  return /*#__PURE__*/_jsx("a", {
    id: id,
    className: "prezly-slate-video__play-button-overlay",
    href: href,
    rel: "noopener noreferer",
    target: "blank",
    title: title,
    children: /*#__PURE__*/_jsx(PlayButton, {
      className: "prezly-slate-video__play-button-icon"
    })
  });
}